import { createContext, useContext } from 'react'

/**
 * True for anything rendered inside a modal dialog or alert dialog. Floating layers
 * that portal to `<body>` (popovers, comboboxes) read this so they stay interactive
 * while the dialog locks pointer events and scrolling outside itself.
 */
export const InsideDialogContext = createContext(false)

export const useInsideDialog = () => useContext(InsideDialogContext)
